// Token Expiration Warning Actions
export const SHOW_EXPIRATION_WARNING = 'SHOW_EXPIRATION_WARNING';
export const HIDE_EXPIRATION_WARNING = 'HIDE_EXPIRATION_WARNING';
export const RENEW_TOKEN = 'RENEW_TOKEN';
export const RENEW_TOKEN_SUCCESS = 'RENEW_TOKEN_SUCCESS';
export const RENEW_TOKEN_FAILURE = 'RENEW_TOKEN_FAILURE';
export const START_EXPIRATION_MONITORING = 'START_EXPIRATION_MONITORING';
export const STOP_EXPIRATION_MONITORING = 'STOP_EXPIRATION_MONITORING';
export const CHECK_TOKEN_EXPIRATION = 'CHECK_TOKEN_EXPIRATION';
export const DISMISS_WARNING = 'DISMISS_WARNING';

// Action Creators
export const showExpirationWarning = (timeRemaining, expiresAt) => ({
  type: SHOW_EXPIRATION_WARNING,
  payload: { timeRemaining, expiresAt }
});

export const hideExpirationWarning = () => ({
  type: HIDE_EXPIRATION_WARNING
});

export const renewToken = () => ({
  type: RENEW_TOKEN
});

export const renewTokenSuccess = (newToken, newExpiresAt) => ({
  type: RENEW_TOKEN_SUCCESS,
  payload: { newToken, newExpiresAt }
});

export const renewTokenFailure = (error) => ({
  type: RENEW_TOKEN_FAILURE,
  payload: { error }
});

export const startExpirationMonitoring = () => ({
  type: START_EXPIRATION_MONITORING
});

export const stopExpirationMonitoring = () => ({
  type: STOP_EXPIRATION_MONITORING
});

export const checkTokenExpiration = () => ({
  type: CHECK_TOKEN_EXPIRATION
});

export const dismissWarning = () => ({
  type: DISMISS_WARNING
});
